export default {
  HOMEPAGE: 'https://www.zxyun.net',
  DOMAIN: '.zxyun.net'
}



//////////////////
// WEBPACK FOOTER
// ./static/config.js
// module id = null
// module chunks = 